export const FETCH_VIDEO_REQUEST = 'FETCH_VIDEO_REQUEST';
export const FETCH_VIDEO_SUCCESS = 'FETCH_VIDEO_SUCCESS';
export const FETCH_VIDEO_FAILURE = 'FETCH_VIDEO_FAILURE';

export const GET_SECTION_BY_VIDEO_FROM_MENU = 'GET_SECTION_BY_VIDEO_FROM_MENU';
